const SalaryDeviation = {
  Employee: "SalaryDeviation.Employee",
  Type: "SalaryDeviation.Type",
  TimePeriod: "SalaryDeviation.TimePeriod",
  Type_1: "SalaryDeviation.Type_1",
  Type_2: "SalaryDeviation.Type_2",
  Type_3: "SalaryDeviation.Type_3",
  Type_4: "SalaryDeviation.Type_4",
  Type_5: "SalaryDeviation.Type_5",
  Type_6: "SalaryDeviation.Type_6",
  Type_7: "SalaryDeviation.Type_7",
  Type_8: "SalaryDeviation.Type_8",
  Type_9: "SalaryDeviation.Type_9",
  Type_10: "SalaryDeviation.Type_10",
  Type_11: "SalaryDeviation.Type_11",
  Type_12: "SalaryDeviation.Type_12",
  Type_13: "SalaryDeviation.Type_13",
  Type_14: "SalaryDeviation.Type_14",
  Type_15: "SalaryDeviation.Type_15",
  Type_16: "SalaryDeviation.Type_16",
  Type_17: "SalaryDeviation.Type_17",
  Type_20: "SalaryDeviation.Type_20",
  Type_21: "SalaryDeviation.Type_21",
  Type_22: "SalaryDeviation.Type_22",
  Type_23: "SalaryDeviation.Type_23",
  Type_24: "SalaryDeviation.Type_24",
  Type_25: "SalaryDeviation.Type_25",
  Type_26: "SalaryDeviation.Type_26",
  Type_27: "SalaryDeviation.Type_27",
  Type_28: "SalaryDeviation.Type_28",
  Type_29: "SalaryDeviation.Type_29",
  Type_30: "SalaryDeviation.Type_30",
  Type_31: "SalaryDeviation.Type_31",
  Type_32: "SalaryDeviation.Type_32",
  Type_33: "SalaryDeviation.Type_33",
  Type_34: "SalaryDeviation.Type_34",
  Type_35: "SalaryDeviation.Type_35",
  Type_36: "SalaryDeviation.Type_36",
  Type_37: "SalaryDeviation.Type_37",
  Type_38: "SalaryDeviation.Type_38",
  Type_39: "SalaryDeviation.Type_39",
  Type_40: "SalaryDeviation.Type_40",
  NameOfDeviation: "SalaryDeviation.NameOfDeviation",
  CreateDeviationTypeHeader: "SalaryDeviation.CreateDeviationTypeHeader",
  CreateDeviationTypeSubHeader: "SalaryDeviation.CreateDeviationTypeSubHeader",
  DeviationTypeSavedSuccessMessage: "SalaryDeviation.DeviationTypeSavedSuccessMessage",
  Deviations: "SalaryDeviation.Deviations",
  EmployeesSalaryDeviations: "SalaryDeviation.EmployeesSalaryDeviations",
  ToApprove: "SalaryDeviation.ToApprove",
  ToDoHeader: "SalaryDeviation.ToDoHeader",
  GoToReport: "SalaryDeviation.GoToReport",
  SelectionHeader: "SalaryDeviation.SelectionHeader",
  SelectionSubHeader: "SalaryDeviation.SelectionSubHeader",
  SelectionSubHeaderPart2: "SalaryDeviation.SelectionSubHeaderPart2",
  NewCompensation: "SalaryDeviation.NewCompensation",
  NewTimeDeviation: "SalaryDeviation.NewTimeDeviation",
  CreatedLeaveSuccess: "SalaryDeviation.CreatedLeaveSuccess",
  DeleteLeaveSuccess: "SalaryDeviation.DeleteLeaveSuccess",
  CreateAllowance: "SalaryDeviation.CreateAllowance",
  EditAllowance: "SalaryDeviation.EditAllowance",
  CreatedAllowanceSuccess: "SalaryDeviation.CreatedAllowanceSuccess",
  DeleteAllowanceSuccess: "SalaryDeviation.DeleteAllowanceSuccess",
  Mileage: "SalaryDeviation.Mileage",
  TypeOfDeviation: "SalaryDeviation.TypeOfDeviation",
  TypeOfAllowance: "SalaryDeviation.TypeOfAllowance",
  Children: "SalaryDeviation.Children",
  ChildrenHelpText: "SalaryDeviation.ChildrenHelpText",
  DeviationsDays: "SalaryDeviation.DeviationsDays",
  FillHours: "SalaryDeviation.FillHours",
  Description: "SalaryDeviation.Description",
  CostDeduction: "SalaryDeviation.CostDeduction",
  Breakfast: "SalaryDeviation.Breakfast",
  Lunch: "SalaryDeviation.Lunch",
  Dinner: "SalaryDeviation.Dinner",
  FromTime: "SalaryDeviation.FromTime",
  ToTime: "SalaryDeviation.ToTime",
  TypeOfCar: "SalaryDeviation.TypeOfCar",
  CarType_0: "SalaryDeviation.CarType_0",
  CarType_1: "SalaryDeviation.CarType_1",
  CarType_2: "SalaryDeviation.CarType_2",
  CarType_3: "SalaryDeviation.CarType_3",
  SubmitSuccessMessage: "SalaryDeviation.SubmitSuccessMessage",
  FromAndTwoDatesShouldBeInExistingDeviationMonth: "SalaryDeviation.FromAndTwoDatesShouldBeInExistingDeviationMonth",
  SalaryState_0: "SalaryDeviation.SalaryState_0",
  SalaryState_1: "SalaryDeviation.SalaryState_1",
  SalaryState_2: "SalaryDeviation.SalaryState_2",
  PaidSalary: "SalaryDeviation.PaidSalary",
  SubmittedDeviations: "SalaryDeviation.SubmittedDeviations",
  NoDeviations: "SalaryDeviation.NoDeviations",
  LockTooltipText: "SalaryDeviation.LockTooltipText",
  AddTimeDeviation: "SalaryDeviation.AddTimeDeviation",
  EditTimeDeviation: "SalaryDeviation.EditTimeDeviation",
  AddCompensation: "SalaryDeviation.AddCompensation",
  RemoveDeviation: "SalaryDeviation.RemoveDeviation",
  AddDeviation: "SalaryDeviation.AddDeviation",
  Submit: "SalaryDeviation.Submit",
  DeleteAllowanceQuestion: "SalaryDeviation.DeleteAllowanceQuestion",
  DeleteDeviationQuestion: "SalaryDeviation.DeleteDeviationQuestion",
  DeleteWarningAllowance: "SalaryDeviation.DeleteWarningAllowance",
  DeleteWarningDeviation: "SalaryDeviation.DeleteWarningDeviation",
  ConnectedToProjectTimeInfoMessage: "SalaryDeviation.ConnectedToProjectTimeInfoMessage",
  TypeDescription_22: "SalaryDeviation.TypeDescription_22",
  TypeDescription_23: "SalaryDeviation.TypeDescription_23",
  TypeDescription_24: "SalaryDeviation.TypeDescription_24",
  TypeDescription_25: "SalaryDeviation.TypeDescription_25",
  TypeDescription_26: "SalaryDeviation.TypeDescription_26",
  TypeDescription_27: "SalaryDeviation.TypeDescription_27",
  TypeDescription_28: "SalaryDeviation.TypeDescription_28",
  TypeDescription_29: "SalaryDeviation.TypeDescription_29",
  TypeDescription_30: "SalaryDeviation.TypeDescription_30",
  TypeDescription_31: "SalaryDeviation.TypeDescription_31",
  TypeDescription_32: "SalaryDeviation.TypeDescription_32",
  TypeDescription_33: "SalaryDeviation.TypeDescription_33",
  TypeDescription_34: "SalaryDeviation.TypeDescription_34",
  TypeDescription_35: "SalaryDeviation.TypeDescription_35",
  TypeDescription_36: "SalaryDeviation.TypeDescription_36",
  TypeDescription_37: "SalaryDeviation.TypeDescription_37",
  TypeDescription_38: "SalaryDeviation.TypeDescription_38",
  TypeDescription_39: "SalaryDeviation.TypeDescription_39",
  ConfirmMonthDeviations: "SalaryDeviation.ConfirmMonthDeviations",
  ConfirmMonthDeviationsDescription: "SalaryDeviation.ConfirmMonthDeviationsDescription",
  CreateDeviation: "SalaryDeviation.CreateDeviation",
  EditDeviation: "SalaryDeviation.EditDeviation",
  ViewDeviation: "SalaryDeviation.ViewDeviation",
  ReadOnlyLockedPeriodMessage: "SalaryDeviation.ReadOnlyLockedPeriodMessage",
  DeviationTypeLabel: "SalaryDeviation.DeviationTypeLabel",
  DeviationType_0: "SalaryDeviation.DeviationType_0",
  DeviationType_1: "SalaryDeviation.DeviationType_1",
  DeviationType_2: "SalaryDeviation.DeviationType_2",
  DeviationType_3: "SalaryDeviation.DeviationType_3",
  AbsenceRegistrationLable: "SalaryDeviation.AbsenceRegistrationLable",
  WorkTimeRegistrationLable: "SalaryDeviation.WorkTimeRegistrationLable",
  CompensationRegistrationLable: "SalaryDeviation.CompensationRegistrationLable",
  TimeBalancesRegistrationLable: "SalaryDeviation.TimeBalancesRegistrationLable",
  DeviationSuggestionLable: "SalaryDeviation.DeviationSuggestionLable",
  CompensationMonthDescription: "SalaryDeviation.CompensationMonthDescription",
  CompensationCommentDescription: "SalaryDeviation.CompensationCommentDescription",
  CompTimeMonthDescription: "SalaryDeviation.CompTimeMonthDescription",
  CompTimeHours: "SalaryDeviation.CompTimeHours",
  CompTimeHoursDescription: "SalaryDeviation.CompTimeHoursDescription",
  Month: "SalaryDeviation.Month",
  AddCompensationLabel: "SalaryDeviation.AddCompensationLabel",
  CommissionAmountLabel: "SalaryDeviation.CommissionAmountLabel",
  CommissionDescriptionHint: "SalaryDeviation.CommissionDescriptionHint",
  OtherInformation: "SalaryDeviation.OtherInformation",
  DeviationReportTypeLable: "SalaryDeviation.DeviationReportTypeLable",
  DeviationReportType_0: "SalaryDeviation.DeviationReportType_0",
  DeviationReportType_1: "SalaryDeviation.DeviationReportType_1",
  DeviationReportType_2: "SalaryDeviation.DeviationReportType_2",
  PercentageDescription: "SalaryDeviation.PercentageDescription",
  TimeDescription: "SalaryDeviation.TimeDescription",
  FillPerDayHours: "SalaryDeviation.FillPerDayHours",
  DeviationCreatedSuccess: "SalaryDeviation.DeviationCreatedSuccess",
  DeviationUpdatedSuccess: "SalaryDeviation.DeviationUpdatedSuccess",
  DeleteDeviationSuccess: "SalaryDeviation.DeleteDeviationSuccess",
  WintTodoHeader: "SalaryDeviation.WintTodoHeader",
  WintTodoDescription: "SalaryDeviation.WintTodoDescription",
  WintTodoSumTitle: "SalaryDeviation.WintTodoSumTitle",
  WintTodoCompareWithPreviousMonth: "SalaryDeviation.WintTodoCompareWithPreviousMonth",
  WintTodoSalaryBreakdownTitle: "SalaryDeviation.WintTodoSalaryBreakdownTitle",
  WintTodoNetSalary: "SalaryDeviation.WintTodoNetSalary",
  WintTodoRemainingNetSalary: "SalaryDeviation.WintTodoRemainingNetSalary",
  WintTodoPayoutDate: "SalaryDeviation.WintTodoPayoutDate",
  WintTodoPayoutDateCapitalized: "SalaryDeviation.WintTodoPayoutDateCapitalized",
  WintTodoCustomerPayoutDate: "SalaryDeviation.WintTodoCustomerPayoutDate",
  WintTodoCustomerPayoutDateCapitalized: "SalaryDeviation.WintTodoCustomerPayoutDateCapitalized",
  WintTodoCustomerPayAsSoonAsPossible: "SalaryDeviation.WintTodoCustomerPayAsSoonAsPossible",
  WintTodoApproveBefore: "SalaryDeviation.WintTodoApproveBefore",
  WintTodoApproveNowForPayoutOn: "SalaryDeviation.WintTodoApproveNowForPayoutOn",
  WintTodoApproveAsSoonAsPossible: "SalaryDeviation.WintTodoApproveAsSoonAsPossible",
  WintTodoAlreadyPaid: "SalaryDeviation.WintTodoAlreadyPaid",
  WintTodoNetSalaryToApprove: "SalaryDeviation.WintTodoNetSalaryToApprove",
  WintTodoAlreadyApprovedExtras: "SalaryDeviation.WintTodoAlreadyApprovedExtras",
  WintTodoOwnPayoutDates: "SalaryDeviation.WintTodoOwnPayoutDates",
  WintTodoExtraSalaryNotice: "SalaryDeviation.WintTodoExtraSalaryNotice",
  WintTodoAmountToApprove: "SalaryDeviation.WintTodoAmountToApprove",
  WintTodoSocialFees: "SalaryDeviation.WintTodoSocialFees",
  WintTodoPersonalTaxes: "SalaryDeviation.WintTodoPersonalTaxes",
  AccumulatorBalanceHeader: "SalaryDeviation.AccumulatorBalanceHeader",
  AccumulatorChangeHeader: "SalaryDeviation.AccumulatorChangeHeader",
  AccumulatorTotalHeader: "SalaryDeviation.AccumulatorTotalHeader",
  UserPayoutDetailsTaxTable: "SalaryDeviation.UserPayoutDetailsTaxTable",
  UserPayoutPrivateTaxNote: "SalaryDeviation.UserPayoutPrivateTaxNote",
  UserPayoutTotalNetSalary: "SalaryDeviation.UserPayoutTotalNetSalary",
  UserPayoutPaidOnDate: "SalaryDeviation.UserPayoutPaidOnDate",
  UserPayoutSettledOnDate: "SalaryDeviation.UserPayoutSettledOnDate",
  UserPayoutCustomerPaysOnDate: "SalaryDeviation.UserPayoutCustomerPaysOnDate",
  UserPayoutCustomerPaysAsSoonAsPossible: "SalaryDeviation.UserPayoutCustomerPaysAsSoonAsPossible",
  SalaryMonth: "SalaryDeviation.SalaryMonth",
  UserPayoutPaidOut: "SalaryDeviation.UserPayoutPaidOut",
  UserPayoutEarlyPayouts: "SalaryDeviation.UserPayoutEarlyPayouts",
  AdjustSalary: "SalaryDeviation.AdjustSalary",
  WorkedTime: "SalaryDeviation.WorkedTime",
  Absence: "SalaryDeviation.Absence",
  TimeBalances: "SalaryDeviation.TimeBalances",
  Compensations: "SalaryDeviation.Compensations",
  CurrentMonth: "SalaryDeviation.CurrentMonth",
  PreviousMonth: "SalaryDeviation.PreviousMonth",
  CurrentVacationYear: "SalaryDeviation.CurrentVacationYear",
  AllHistory: "SalaryDeviation.AllHistory",
  DeviationCategory: "SalaryDeviation.DeviationCategory",
  DeviationCategory_0: "SalaryDeviation.DeviationCategory_0",
  DeviationCategory_1: "SalaryDeviation.DeviationCategory_1",
  DeviationCategory_2: "SalaryDeviation.DeviationCategory_2",
  DeviationCategory_3: "SalaryDeviation.DeviationCategory_3",
  SearchEmployee: "SalaryDeviation.SearchEmployee",
  DeviationType: "SalaryDeviation.DeviationType",
  VariationOverTime: "SalaryDeviation.VariationOverTime",
  DeleteDeviationDescription: "SalaryDeviation.DeleteDeviationDescription",
  DeletePeriodOption_OpenedPeriod: "SalaryDeviation.DeletePeriodOption_OpenedPeriod",
  DeletePeriodOption_SelectedPeriod: "SalaryDeviation.DeletePeriodOption_SelectedPeriod",
  DeletePeriodOption_All: "SalaryDeviation.DeletePeriodOption_All",
  ReApproveSalaryPreviewTitle: "SalaryDeviation.ReApproveSalaryPreviewTitle",
  ReApproveSalaryPreviewResultLabel: "SalaryDeviation.ReApproveSalaryPreviewResultLabel",
  ReApproveSalaryPreviewResultEmployeeSalary: "SalaryDeviation.ReApproveSalaryPreviewResultEmployeeSalary",
  ReApproveSalaryPreviewDescription: "SalaryDeviation.ReApproveSalaryPreviewDescription",
  ReApproveSalaryPreviewChangesLabel: "SalaryDeviation.ReApproveSalaryPreviewChangesLabel",
  ReApproveSalaryPreviewChangesCurrentDateRange: "SalaryDeviation.ReApproveSalaryPreviewChangesCurrentDateRange",
  ReApproveSalaryPreviewChangesPreviousDateRange: "SalaryDeviation.ReApproveSalaryPreviewChangesPreviousDateRange",
  ReApproveSalaryPreviewSave: "SalaryDeviation.ReApproveSalaryPreviewSave",
  ReApproveSuccessMessage: "SalaryDeviation.ReApproveSuccessMessage",
  LockedPeriodReApprovalWarning: "SalaryDeviation.LockedPeriodReApprovalWarning",
  CorrectionDeletion: "SalaryDeviation.CorrectionDeletion",
  Child: "SalaryDeviation.Child",
  ChildPlaceholder: "SalaryDeviation.ChildPlaceholder",
  CreateChildDialogTitle: "SalaryDeviation.CreateChildDialogTitle",
  ChildName: "SalaryDeviation.ChildName",
  ChildDateOfBirth: "SalaryDeviation.ChildDateOfBirth",
  ChildSoleCustody: "SalaryDeviation.ChildSoleCustody",
  ChildCreatedSuccess: "SalaryDeviation.ChildCreatedSuccess",
  WithdrawalMonthDescription: "SalaryDeviation.WithdrawalMonthDescription",
  DepositMonthDescription: "SalaryDeviation.DepositMonthDescription",
  WithdrawalAmount: "SalaryDeviation.WithdrawalAmount",
  WithdrawalMaxDescription: "SalaryDeviation.WithdrawalMaxDescription",
  WithdrawalAvailableBalance: "SalaryDeviation.WithdrawalAvailableBalance",
  WithdrawalSavedSalaryPot: "SalaryDeviation.WithdrawalSavedSalaryPot",
  WithdrawalVacationPayPot: "SalaryDeviation.WithdrawalVacationPayPot",
  WithdrawalBalanceUnavailable: "SalaryDeviation.WithdrawalBalanceUnavailable",
  WithdrawalExceedsBalance: "SalaryDeviation.WithdrawalExceedsBalance",
  UseCurrentMonthPlacement: "SalaryDeviation.UseCurrentMonthPlacement",
  UseCurrentMonthPlacementHelpText: "SalaryDeviation.UseCurrentMonthPlacementHelpText",
  PlacementInheritedToArrears: "SalaryDeviation.PlacementInheritedToArrears",
  PlacementInheritedToCurrentMonth: "SalaryDeviation.PlacementInheritedToCurrentMonth",
  FuelBenefitCost: "SalaryDeviation.FuelBenefitCost",
  FuelBenefitCostDescription: "SalaryDeviation.FuelBenefitCostDescription",
  FuelBenefitPrivateDistance: "SalaryDeviation.FuelBenefitPrivateDistance",
  FuelBenefitBusinessDistance: "SalaryDeviation.FuelBenefitBusinessDistance",
  FuelBenefitBusinessDistanceDescription: "SalaryDeviation.FuelBenefitBusinessDistanceDescription",
  FuelBenefitDistanceUnit: "SalaryDeviation.FuelBenefitDistanceUnit",
  FuelBenefitPrivateShare: "SalaryDeviation.FuelBenefitPrivateShare",
  FuelBenefitPrivateShareDescription: "SalaryDeviation.FuelBenefitPrivateShareDescription",
  FuelBenefitTotalDistanceRequired: "SalaryDeviation.FuelBenefitTotalDistanceRequired",
  FuelBenefitCostRequired: "SalaryDeviation.FuelBenefitCostRequired",
  }
export default SalaryDeviation;